module.exports = __webpack_public_path__ + "assets/img/c385-se.svg";